const signs = [
  "You&rsquo;ve stopped naming what you actually want.",
  "Your work feels safe, and quietly bored.",
  "There&rsquo;s a sentence you keep almost writing.",
  "You&rsquo;ve started calling rest \u201cwasting time.\u201d",
  "Other people&rsquo;s lives feel more vivid than yours.",
  "The thing you almost made still hasn&rsquo;t been made.",
];

export default function Philosophy() {
  return (
    <section
      id="philosophy"
      data-testid="philosophy-section"
      className="bg-[#FFFFFF] border-b border-[#E5E0D8]"
    >
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-24 md:py-32">
        <div className="grid grid-cols-12 gap-8 items-end mb-14">
          <div className="col-span-12 md:col-span-8" data-reveal>
            <div className="text-[11px] uppercase tracking-[0.28em] text-[#1FA5B8] font-body">
              Signs you&apos;ve been listening less
            </div>
            <h2 className="mt-4 font-display text-[#1A1A1A] leading-[1.02] tracking-tight text-[clamp(2.25rem,5vw,4rem)] font-medium">
              When creativity falls{" "}
              <span className="italic font-light">quiet</span>, it doesn&apos;t
              announce itself.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-4 md:col-start-9" data-reveal>
            <p className="font-body text-[#5C5C5C] text-base md:text-lg leading-relaxed">
              It changes the way the days feel before it changes anything else.
              The signs are quiet, easy to miss, easier to dismiss.
            </p>
          </div>
        </div>

        <ul className="grid grid-cols-12 gap-x-8 gap-y-6">
          {signs.map((s, i) => (
            <li
              key={i}
              data-testid={`sign-${i + 1}`}
              data-reveal
              className="col-span-12 md:col-span-6 border-t border-[#1A1A1A] pt-5 pr-2 group"
            >
              <div className="flex items-baseline justify-between mb-3">
                <span className="font-display text-[20px] leading-none tracking-tight text-[#1FA5B8]">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="text-[10px] uppercase tracking-[0.3em] text-[#5C5C5C] font-body">
                  A small noticing
                </span>
              </div>
              <p
                className="font-display text-[#1A1A1A] text-[22px] md:text-[24px] leading-[1.35]"
                dangerouslySetInnerHTML={{ __html: s }}
              />
            </li>
          ))}
        </ul>

        <div className="mt-20 max-w-3xl mx-auto text-center" data-reveal>
          <p className="font-display italic text-[#1A1A1A] text-[clamp(1.5rem,2.6vw,2rem)] leading-[1.4]">
            None of these mean you&apos;re broken.
          </p>
          <p className="mt-3 font-display text-[#1FA5B8] text-[clamp(1.5rem,2.6vw,2rem)] leading-[1.4]">
            They mean something inside you is waiting.
          </p>
        </div>
      </div>
    </section>
  );
}
